import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { APP_ROUTES } from '@core/constants/app-routes';
import { AuthStorageService } from '../services/auth-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private readonly storage: AuthStorageService,
    private readonly router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.storage.isTokenValid()) {
      return true;
    }

    this.storage.clearSession();
    return this.router.createUrlTree([APP_ROUTES.auth.login]);
  }
}
